import { render, staticRenderFns } from "./DblDistribTask.vue?vue&type=template&id=83b1277e&"
import script from "./DblDistribTask.vue?vue&type=script&lang=js&"
export * from "./DblDistribTask.vue?vue&type=script&lang=js&"
import style0 from "./DblDistribTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports